import { FormGroup } from '@angular/forms';
import { addRemoveError, getControl, getGroup } from '@shared/helpers/form.helper';
import { isNilOrEmpty } from '@shared/helpers/utils.helper';
import { cloneDeep, isEqual } from 'lodash-es';
import { REQUIRED_STATUS } from '@shared/constants/shared.constants';
import { Store } from '@ngrx/store';
import { Revisione53State } from '../../../../store/revisione53.reducers';
import { updateVerbaleOnStore } from '@core/helpers/create-validator.helper';
import { MyVerbale } from '../../../../models/interfaces/revisione.interface';
import { CkNormeValues } from '../models/amm-controllo.type';
import { formPaths } from '@shared/constants/form-paths.const';

export const getGroupByCkNorme = (ckNormeValue: CkNormeValues): string => {
    switch (ckNormeValue) {
        case '1':
            return 'my_NormeSrl';
        case '2':
            return 'my_NormeSpaOrdinario';
        case '3':
            return 'my_NormeSpaDualistico';
        case '4':
            return 'my_NormeSpaMonistico';
    }
};

export const getTipoAmministrazioneFieldByCkNorme = (ckNormeValue: CkNormeValues): string => {
    switch (ckNormeValue) {
        case '1':
            return 'my_CkSrlTipoAmministrazione';
        case '2':
            return 'my_CkSpoTipoAmministrazione';
        case '4':
            return 'my_CkSpmTipoAmministrazione';
    }
};

export const getRevisioneCkByCkNorme = (ckNormeValue: CkNormeValues): string => {
    switch (ckNormeValue) {
        case '1':
            return 'my_CkSrlAffidamContrCont';
        case '2':
            return 'my_CkSpoAffidamContrCont';
        case '3':
            return 'my_CkSpdAffidamContrCont';
        case '4':
            return 'my_CkSpmAffidamContrCont';
    }
};

export const checkCkNormeValueHelper = (form: FormGroup, ckNormeTarget: CkNormeValues): boolean => {
    const my_ckNorme: string = getControl(form, `${formPaths.ammControllo}.my_CkNorme`).value;
    return my_ckNorme === ckNormeTarget;
};

export const checkCkNormeValueRequiredHelper = (form: FormGroup, targetPath: string, ckNormeTarget: CkNormeValues, subFormPath: string): void => {
    const subGroup = getGroup(form, subFormPath);
    const targetControl = getControl(subGroup, targetPath);
    const targetValue: string = targetControl.value;
    const targetNameSplitted = targetPath?.split('.');
    const errorName = targetNameSplitted[targetNameSplitted?.length - 1];
    const errors = targetControl.errors ? targetControl.errors : {};

    addRemoveError(isNilOrEmpty(targetValue) && checkCkNormeValueHelper(form, ckNormeTarget), errors, errorName, {
        status: REQUIRED_STATUS,
    });

    targetControl.setErrors(isEqual(errors, {}) ? null : errors);
};

export const setRequiredIfNormeActiveAndSecondFilledHelper = (
    form: FormGroup,
    targetPath: string,
    secondFieldPath: string,
    ckNormeTarget: CkNormeValues,
    subFormPath: string,
    message?: string
): void => {
    const subGroup = getGroup(form, subFormPath);
    const targetControl = getControl(subGroup, targetPath);
    const secondField = getControl(subGroup, secondFieldPath).value;
    const targetNameSplitted = targetPath?.split('.');
    const errorName = targetNameSplitted[targetNameSplitted?.length - 1];
    const errors = targetControl.errors ? targetControl.errors : {};

    addRemoveError(
        checkCkNormeValueHelper(form, ckNormeTarget) && isNilOrEmpty(targetControl.value) && secondField?.length > 0,
        errors,
        errorName,
        message ? { status: REQUIRED_STATUS, message } : { status: REQUIRED_STATUS }
    );

    targetControl.setErrors(isEqual(errors, {}) ? null : errors);
};

export const setCkNorme = (form: FormGroup, store: Store<Revisione53State>, value: string): void => {
    getControl(form, `${formPaths.ammControllo}.my_CkNorme`).setValue(value);
    updateVerbaleOnStore(store, (myVerbale) => {
        const v: MyVerbale = cloneDeep(myVerbale);
        v.my_SezioneI__Rilevazione.my_AmministrazioneControllo.my_CkNorme = value;
        return v;
    });
};
